import axios from "axios";

export const API_BASE = process.env.REACT_APP_BACKEND_URL;
export const api = axios.create({ baseURL: `${API_BASE}/api` });

export function getAssetUrl(url) {
  if (!url || url.startsWith("http")) {
    return url;
  }
  return `${API_BASE}${url}`;
}

export function adminHeaders() {
  const token = localStorage.getItem("eylul-admin-token");
  return { Authorization: `Bearer ${token}` };
}